"use strict";exports.__esModule = true;exports.delay = void 0;var _globalObject = require("@skbkontur/global-object");

var delay = exports.delay = function delay(ms) {return new Promise(function (resolve) {return _globalObject.globalObject.setTimeout(resolve, ms);});};